import { PackageTypeEnum } from '../domain';
import { z } from 'zod';

export const SyncResponse = z.object({
  id: z.string(),
  version: z.string(),
  type: z.nativeEnum(PackageTypeEnum),
  created: z.boolean(),
  key: z.string().optional(),
  debug: z.any().optional(),
});
